<div class="{{ theme }} {{ className }}__filter-wrapper">
  <div class="{{ className }}__filter {{ classFilter }}">
    <input
      #search
      (blur)="removeClassFocus()"
      (focus)="addClassFocus()"
      (keyup)="onInputFilter($event)"
      [(ngModel)]="searchInput"
      autocomplete="off"
      class="{{ className }}__input"
      id="{{ className }}_input-filter-search"
      placeholder="{{ placeholder }}"
      type="search" />
    <mat-icon class="material-symbols-outlined prefix">search</mat-icon>
    @if (searchInput) {
      <mat-icon
        (click)="
          searchInput = '';
          onClearFilter({
            clear: true
          })
        "
        class="material-symbols-outlined suffix"
        >close
      </mat-icon>
    }
  </div>
</div>